import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActions = ({ selectedCount, onBulkAction }) => {
  const [isPerforming, setIsPerforming] = useState(false);

  const handleBulkAction = async (action) => {
    setIsPerforming(true);
    try {
      await onBulkAction(action);
      // In a real app, show success message
    } catch (error) {
      console.error(`Bulk ${action} failed:`, error);
      // In a real app, show error message
    } finally {
      setIsPerforming(false);
    }
  };

  const bulkActions = [
    {
      id: 'export',
      label: 'Export Selected',
      icon: 'Download',
      description: 'Export selected transactions',
      variant: 'default'
    },
    {
      id: 'verify',
      label: 'Verify',
      icon: 'Shield',
      description: 'Re-verify selected archives',
      variant: 'outline'
    },
    {
      id: 'archive',
      label: 'Archive',
      icon: 'Archive',
      description: 'Move to archive folder',
      variant: 'outline'
    },
    {
      id: 'delete',
      label: 'Delete',
      icon: 'Trash2',
      description: 'Delete selected transactions',
      variant: 'destructive'
    }
  ];

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
      <div className="flex flex-col md:flex-row md:items-center justify-between space-y-4 md:space-y-0">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
            <Icon name="Check" size={16} color="white" />
          </div>
          <div>
            <p className="font-medium text-foreground">
              {selectedCount} transaction{selectedCount !== 1 ? 's' : ''} selected
            </p>
            <p className="text-sm text-muted-foreground">
              Choose an action to perform on selected items
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-2 overflow-x-auto">
          {bulkActions?.map((action) => (
            <Button
              key={action?.id}
              variant={action?.variant}
              size="sm"
              iconName={action?.icon}
              loading={isPerforming}
              onClick={() => handleBulkAction(action?.id)}
              className="whitespace-nowrap"
              title={action?.description}
            >
              {action?.label}
            </Button>
          ))}
        </div>
      </div>

      {/* Quick Stats for Selected */}
      <div className="mt-4 pt-4 border-t border-primary/20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <div className="text-center">
            <p className="font-medium text-foreground">{selectedCount}</p>
            <p className="text-muted-foreground">Selected</p>
          </div>
          <div className="text-center">
            <p className="font-medium text-green-600">--</p>
            <p className="text-muted-foreground">Confirmed</p>
          </div>
          <div className="text-center">
            <p className="font-medium text-yellow-600">--</p>
            <p className="text-muted-foreground">Pending</p>
          </div>
          <div className="text-center">
            <p className="font-medium text-blue-600">-- MB</p>
            <p className="text-muted-foreground">Total Size</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;